import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import _imports_0 from './../../assets/image/small.gif';
const _hoisted_1 = {
  class: "qc-loading"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock(_Transition, {
    name: "loading-fade"
  }, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [_createElementVNode("img", {
      src: _imports_0,
      class: "qc-loading-icon",
      alt: ""
    }, null, -1)]))], 512), [[_vShow, $setup.isVisible]])]),
    _: 1
  });
}